import styled, { keyframes } from "styled-components";

const ellipsisDotFade = keyframes`
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const EllipsisDot = styled.span`
  opacity: 0;
  animation: ${ellipsisDotFade} 1.5s linear infinite;
`;

const LoadingButtonText = styled.span`
  span:nth-child(1) {
    animation-delay: 0s;
  }
  span:nth-child(2) {
    animation-delay: 0.2s;
  }
  span:nth-child(3) {
    animation-delay: 0.3s;
  }
`;

const PulsingEllipsis = () => {
  return (
    <LoadingButtonText>
      <EllipsisDot>.</EllipsisDot>
      <EllipsisDot>.</EllipsisDot>
      <EllipsisDot>.</EllipsisDot>
    </LoadingButtonText>
  );
};

export default PulsingEllipsis;
